import jetpackCmd from './jetpack/cmd/_root';
import { JetpackClient as client, jetroutineWrapper } from './jetpack/core/client';
import { cron as cronjob } from './jetpack/core/cron';

// Using esm export style here because we are compiling from
// Typescript module code to esm + commonjs. The regular syntax of
// module.exports will no longer work in this context.
export const JetpackClient = client;
export const cron = cronjob;
export const cmd = jetpackCmd;
export const jetroutine = jetroutineWrapper;
